import { createContractClient, type ContractClientDependencies } from './contract-client';
import type { ApiRegistry } from './provider';
import { createBackendProvider } from './providers/backend';

export function createBackendApiRegistry(backend: ContractClientDependencies): ApiRegistry {
  return createBackendProvider(createContractClient(backend), { baseUrl: backend.baseUrl });
}
